import { ReactNode } from 'react'
import styled from 'styled-components'

interface Props {
  main: ReactNode
  sub?: ReactNode
}

/** Summary cell value with an optional muted second line — a single line would be cut off in a narrow cell. */
const SummaryValue = ({ main, sub }: Props) => (
  <>
    <Line>{main}</Line>
    {sub != null && <Sub>{sub}</Sub>}
  </>
)

export default SummaryValue

// Each line is its own block: the parent's ellipsis does not reach an anonymous block next to a block sibling.
const Line = styled.span`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
`

const Sub = styled(Line)`
  font-size: ${({ theme }) => theme.text.sm};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.ink3};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: ${({ theme }) => theme.textMobile.sm};
  }
`
